//storage apenas para dados simples
export const SaveObject = (key, value) => {
  return SaveStorage(key, JSON.stringify(value));
};

export const ReadObject = (key) => {
  try {
    return JSON.parse(ReadStorage(key));
  } catch (e) {
    return null;
  }
};

// Armazenamento simples (sem dados sensíveis)
export const SaveStorage = (key, value) => {
  try {
    return localStorage.setItem(key, value);
  } catch (e) {
    return sessionStorage.setItem(key, value);
  }
};

export const ReadStorage = (key) => {
  let value = ``;
  try {
    value = localStorage.getItem(key);
  } catch (e) {
    value = sessionStorage.getItem(key);
  }
  if (value !== '' && value !== null) {
    return value;
  }
  return false;
};
